import React, { useEffect, useState, useRef } from "react";

const PollName = (props) => {
  const activeTimer = useRef(0);

  const [activeTitle, setActiveTitle] = useState(false);

  useEffect(() => {
    activeTimer.current = setInterval(() => {
      setActiveTitle(true);
      setTimeout(() => {
        setActiveTitle(false);
      }, 10000);
    }, 60000);

    return () => {
      clearTimeout(activeTimer.current);
    };
  }, []);
  return (
    <div
      id="poll_name"
      className={"poll_name" + `${activeTitle ? " active" : ""}`}
    >
      {props.children}
    </div>
  );
};

export default PollName;
